import { motion } from "framer-motion";

const photos = [
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777334988/WhatsApp_Image_2026-04-27_at_12.37.05_yraj2r.jpg",
        span: "md:col-span-6 md:row-span-2",
        ratio: "aspect-[4/5]",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777334988/WhatsApp_Image_2026-04-27_at_12.37.05_2_cf59q5.jpg",
        span: "md:col-span-3",
        ratio: "aspect-square",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777334988/WhatsApp_Image_2026-04-27_at_12.37.05_4_tequ0r.jpg",
        span: "md:col-span-3",
        ratio: "aspect-square",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777334988/WhatsApp_Image_2026-04-27_at_12.37.04_hs02yh.jpg",
        span: "md:col-span-6",
        ratio: "aspect-[16/10]",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777334988/WhatsApp_Image_2026-04-27_at_12.37.05_1_pfqnrl.jpg",
        span: "md:col-span-4",
        ratio: "aspect-[4/5]",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777335461/WhatsApp_Image_2026-04-27_at_12.35.07_1_qj0elp.jpg",
        span: "md:col-span-4",
        ratio: "aspect-[4/5]",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777335461/WhatsApp_Image_2026-04-27_at_12.35.07_nzv6vx.jpg",
        span: "md:col-span-4",
        ratio: "aspect-[4/5]",
    },
    {
        src: "https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777335460/WhatsApp_Image_2026-04-27_at_12.35.06_dozkgk.jpg",
        span: "md:col-span-12",
        ratio: "aspect-[21/9]",
    },
];

export default function Gallery() {
    return (
        <section
            id="gallery"
            data-testid="gallery"
            className="relative bg-[#FAF9F6] py-20 sm:py-28 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl mb-12 sm:mb-16"
                >
                    <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#0D9488] mb-4">
                        From last year
                    </p>
                    <h2 className="font-montserrat font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[0.95] text-slate-900 flex items-center gap-4 flex-wrap">
                        <span className="ais-gradient">A taste of the vibe.</span>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
                            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2 }}
                            className="w-32 h-32 sm:w-48 sm:h-48 rounded-2xl overflow-hidden border-2 border-white shadow-lg shrink-0"
                        >
                            <img
                                src="https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777418125/WhatsApp_Image_2026-04-28_at_21.15.17_u41um9.jpg"
                                alt="Gallery highlight"
                                className="w-full h-full object-cover"
                            />
                        </motion.div>
                    </h2>
                    <p className="mt-5 text-slate-700 text-base sm:text-lg max-w-xl">
                        Music, mates, and zero phone-scrolling — here's what
                        you signed up for.
                    </p>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-12 auto-rows-auto gap-4 sm:gap-5">
                    {photos.map((p, idx) => (
                        <motion.figure
                            key={p.src}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{
                                duration: 0.55,
                                delay: (idx % 4) * 0.07,
                            }}
                            whileHover={{ y: -4 }}
                            data-testid={`gallery-item-${idx + 1}`}
                            className={`group relative overflow-hidden rounded-2xl sm:rounded-3xl bg-slate-200 shadow-sm hover:shadow-xl transition-shadow duration-300 ${p.span}`}
                        >
                            <div className={`${p.ratio} w-full`}>
                                <img
                                    src={p.src}
                                    alt={`AIS Festival moment ${idx + 1}`}
                                    loading="lazy"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                                />
                            </div>
                            {/* subtle accent on hover */}
                            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/5 group-hover:ring-[#0D9488]/40 transition-colors duration-300 rounded-2xl sm:rounded-3xl" />
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
